import React from 'react';
import Badge, { BadgeTypes } from '../../Badge';
function FilterBadge(_a) {
    var children = _a.children, colour = _a.colour;
    var badgeType = colour && BadgeTypes[colour] ? colour : BadgeTypes.grey;
    return React.createElement(Badge, { type: badgeType }, children);
}
export default FilterBadge;
